<template>
  <div class="page-container">
    <div class="table-wrapper">
      <div class="table-header">
        <el-button v-auth="'business:thirdPartyConfig:save'" type="primary" size="small" icon="el-icon-plus" @click="openAdd">+ 添加新配置</el-button>
      </div>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="服务分类">
          <el-select v-model="searchForm.serviceParentType" placeholder="全部" clearable style="width:140px;">
            <el-option label="要素认证" :value="1"></el-option>
            <el-option label="OCR识别" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="厂商">
          <el-input v-model="searchForm.vendor" placeholder="输入厂商" clearable style="width:140px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.isDelete" placeholder="全部" clearable style="width:100px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="fetchList">搜索</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column prop="sort" label="排序" width="60" align="center"></el-table-column>
        <el-table-column prop="serviceParentType" label="服务分类" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.serviceParentType === 1 ? 'primary' : 'success'" size="mini">
              {{ scope.row.serviceParentType === 1 ? '要素认证' : 'OCR识别' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="vendor" label="厂商" width="110">
          <template slot-scope="scope"><el-tag type="warning" size="mini">{{ scope.row.vendor }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="serviceSonType" label="服务细项" width="130">
          <template slot-scope="scope">
            <el-tag :type="serviceSonColorTag(scope.row.serviceSonType)" size="mini">{{ serviceSonTypeLabel(scope.row.serviceSonType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="serviceName" label="服务名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="APPKEY" width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ maskAppKey(scope.row.appKey) }}</template>
        </el-table-column>
        <el-table-column prop="isDelete" label="状态" width="70">
          <template slot-scope="scope">
            <el-switch v-auth="'business:thirdPartyConfig:status'" :value="scope.row.isDelete === 1" @change="toggleStatus(scope.row)" active-color="var(--brand-primary)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
            <el-button v-auth="'business:thirdPartyConfig:edit'" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-auth="'business:thirdPartyConfig:delete'" type="text" size="small" style="color:#f56c6c;" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="(v) => { pageSize = v; fetchList(); }"
        @current-change="(v) => { pageNum = v; fetchList(); }"
        :current-page="pageNum" :page-sizes="[10, 50, 100, 500]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <!-- 添加/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="服务分类" required>
              <el-select v-model="form.serviceParentType" placeholder="请选择" style="width:100%;">
                <el-option label="要素认证" :value="1"></el-option>
                <el-option label="OCR识别" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务细项" required>
              <el-select v-model="form.serviceSonType" placeholder="请选择" style="width:100%;">
                <el-option-group label="要素认证">
                  <el-option label="银行卡四要素" :value="2"></el-option>
                  <el-option label="银行卡三要素" :value="1"></el-option>
                  <el-option label="银行卡二要素" :value="3"></el-option>
                  <el-option label="身份证二要素" :value="4"></el-option>
                  <el-option label="手机三要素" :value="5"></el-option>
                  <el-option label="人脸比对" :value="6"></el-option>
                  <el-option label="手机归属地" :value="7"></el-option>
                </el-option-group>
                <el-option-group label="OCR识别">
                  <el-option label="身份证OCR" :value="8"></el-option>
                  <el-option label="银行卡OCR" :value="9"></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="服务名称" required><el-input v-model="form.serviceName" placeholder="如 聚合数据银行卡四要素"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂商" required><el-input v-model="form.vendor" placeholder="如 聚合数据"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="APPKEY" required><el-input v-model="form.appKey" placeholder="APPKEY"></el-input></el-form-item>
        <el-form-item label="APP Secret"><el-input v-model="form.appSecret" placeholder="密钥" show-password></el-input></el-form-item>
        <el-form-item label="接口域名" required><el-input v-model="form.apiHost" placeholder="如 https://api.example.com"></el-input></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="API路径"><el-input v-model="form.apiPath" placeholder="如 /api/bankcard4"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="是否启用"><el-switch v-model="form.isDelete" :active-value="1" :inactive-value="2"></el-switch></el-form-item></el-col>
        </el-row>
        <el-form-item label="额外配置"><el-input type="textarea" :rows="3" v-model="form.configJson" placeholder="JSON"></el-input></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" style="width:200px;"></el-input-number></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗（只读） -->
    <el-dialog title="服务配置详情" :visible.sync="detailVisible" width="620px" :close-on-click-modal="false">
      <el-form v-if="detail" :model="detail" label-width="100px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="服务分类">
              <el-select :value="detail.serviceParentType" disabled style="width:100%;">
                <el-option label="要素认证" :value="1"></el-option>
                <el-option label="OCR识别" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务细项">
              <el-select :value="detail.serviceSonType" disabled style="width:100%;">
                <el-option label="银行卡四要素" :value="2"></el-option>
                <el-option label="银行卡三要素" :value="1"></el-option>
                <el-option label="银行卡二要素" :value="3"></el-option>
                <el-option label="身份证二要素" :value="4"></el-option>
                <el-option label="手机三要素" :value="5"></el-option>
                <el-option label="人脸比对" :value="6"></el-option>
                <el-option label="手机归属地" :value="7"></el-option>
                <el-option label="身份证OCR" :value="8"></el-option>
                <el-option label="银行卡OCR" :value="9"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="服务名称"><el-input :value="detail.serviceName" disabled></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂商"><el-input :value="detail.vendor" disabled></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="APPKEY"><el-input :value="maskAppKey(detail.appKey)" disabled></el-input></el-form-item>
        <el-form-item label="APP Secret"><el-input :value="detail.appSecret || '***'" disabled></el-input></el-form-item>
        <el-form-item label="接口域名"><el-input :value="detail.apiHost" disabled></el-input></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="API路径"><el-input :value="detail.apiPath" disabled></el-input></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="是否启用">
              <el-switch :value="detail.isDelete === 1" disabled></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="额外配置"><el-input type="textarea" :rows="3" :value="detail.configJson" disabled></el-input></el-form-item>
        <el-form-item label="创建时间"><el-input :value="detail.createDate" disabled></el-input></el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  thirdPartyConfigList, thirdPartyConfigAddOrUpdate, thirdPartyConfigDeleteBatchIds,
  thirdPartyConfigStatus
} from '@/api/thirdPartyConfig'

export default {
  name: 'ThirdPartyConfigList',
  data() {
    return {
      searchForm: { serviceParentType: null, vendor: '', isDelete: null },
      tableData: [], loading: false,
      pageNum: 1, pageSize: 10, total: 0,
      dialogVisible: false, dialogTitle: '添加新配置',
      form: { id: null, serviceParentType: 1, serviceSonType: null, serviceName: '', vendor: '', appKey: '', appSecret: '', apiHost: '', apiPath: '', isDelete: 1, configJson: '', sort: 0 },
      editing: false,
      detailVisible: false, detail: null
    }
  },
  mounted() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      thirdPartyConfigList({ pageNum: this.pageNum, pageSize: this.pageSize, serviceParentType: this.searchForm.serviceParentType, vendor: this.searchForm.vendor, isDelete: this.searchForm.isDelete }).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    resetSearch() { this.searchForm = { serviceParentType: null, vendor: '', isDelete: null }; this.fetchList() },
    openAdd() {
      this.editing = false; this.dialogTitle = '添加新配置'
      this.form = { id: null, serviceParentType: 1, serviceSonType: null, serviceName: '', vendor: '', appKey: '', appSecret: '', apiHost: '', apiPath: '', isDelete: 1, configJson: '', sort: 0 }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.editing = true; this.dialogTitle = '编辑配置'
      this.form = { id: row.id, serviceParentType: row.serviceParentType, serviceSonType: row.serviceSonType, serviceName: row.serviceName, vendor: row.vendor, appKey: row.appKey, appSecret: row.appSecret, apiHost: row.apiHost, apiPath: row.apiPath, isDelete: row.isDelete, configJson: row.configJson, sort: row.sort }
      this.dialogVisible = true
    },
    save() {
      if (!this.form.serviceParentType) { this.$message.warning('请选择服务分类'); return }
      if (!this.form.serviceSonType) { this.$message.warning('请选择服务细项'); return }
      if (!this.form.serviceName) { this.$message.warning('请输入服务名称'); return }
      if (!this.form.vendor) { this.$message.warning('请输入厂商'); return }
      if (!this.form.appKey) { this.$message.warning('请输入APPKEY'); return }
      if (!this.form.apiHost) { this.$message.warning('请输入接口域名'); return }
      const data = { id: this.editing ? this.form.id : null, serviceParentType: this.form.serviceParentType, serviceSonType: this.form.serviceSonType, serviceName: this.form.serviceName, vendor: this.form.vendor, appKey: this.form.appKey, appSecret: this.form.appSecret, apiHost: this.form.apiHost, apiPath: this.form.apiPath, isDelete: this.form.isDelete, configJson: this.form.configJson || null, sort: this.form.sort }
      thirdPartyConfigAddOrUpdate(data).then(res => {
        if (res.code === 0) { this.$message.success(this.editing ? '编辑成功' : '添加成功'); this.dialogVisible = false; this.fetchList() }
      })
    },
    deleteItem(row) {
      this.$confirm('确定删除该配置吗？', '提示', { type: 'warning' }).then(() => {
        thirdPartyConfigDeleteBatchIds(String(row.id)).then(res => { if (res.code === 0) { this.$message.success('删除成功'); this.fetchList() } })
      }).catch(() => {})
    },
    toggleStatus(row) {
      thirdPartyConfigStatus(row.id, row.isDelete === 1 ? 2 : 1).then(res => { if (res.code === 0) { this.$message.success('状态更新成功'); this.fetchList() } })
    },
    viewDetail(row) { this.detail = row; this.detailVisible = true },
    serviceSonTypeLabel(t) {
      const m = { 1: '银行卡三要素', 2: '银行卡四要素', 3: '银行卡二要素', 4: '身份证二要素', 5: '手机三要素', 6: '人脸比对', 7: '手机归属地', 8: '身份证OCR', 9: '银行卡OCR' }
      return m[t] || t
    },
    serviceSonColorTag(t) {
      const m = { 1: '', 2: 'danger', 3: 'primary', 4: 'primary', 5: 'warning', 6: 'warning', 7: 'primary', 8: 'success', 9: 'success' }
      return m[t] || ''
    },
    maskAppKey(val) {
      if (!val || val.length <= 10) return val || ''
      const start = Math.floor((val.length - 5) / 2)
      return val.substring(0, start) + '*****' + val.substring(start + 5)
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; background: #f5f7fa; min-height: calc(100vh - 84px); }
.table-wrapper { background: #fff; border-radius: 4px; padding: 16px; }
.table-header { margin-bottom: 12px; }
.search-form { margin-bottom: 12px; background: #fafafa; padding: 12px; border-radius: 4px; }
</style>
